module.exports = __webpack_public_path__ + "img/paperclip.140f230f.svg";